import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const BulkUsersPayments = async (data) => {
  try {
    return await postData(`/ai-trade/bulk-users-payments`, data);
  } catch (error) {
    console.error(error);
  }
};
